// src/App.js
import "./App.css";
import Loading from "./Components/Loading";
import Home from "./Components/Home";
import About from "./Components/About";
import BlackFriday from "./Components/BlackFriday";
import Work from "./Components/Work";
import Results from "./Components/Results";
import Contact from "./Components/Contact";
import Up from "./Components/Up";
import Footer from "./Components/Footer";
import ScrollAnimationProvider from "./Components/ScrollAnimationProvider";
import WhatsAppButton from "./Components/WhatsAppButton";
import useNetworkLoading from "./Hooks/useNetworkLoading";   

function App() {
  useNetworkLoading();            // Monitora chamadas de rede e dispara o loading global SOMENTE quando uma requisição passa de SLOW_THRESHOLD_MS.                           

  return (
    <ScrollAnimationProvider>
      <div className="App">
        <Loading />
        <Home />
        <About />
        <Results />
        <BlackFriday />
        <Work />
        <Contact />
        <Up />
        <Footer />
        <WhatsAppButton />
      </div>
    </ScrollAnimationProvider>
  );
}

export default App;